import "../App.css";
import Backdrop from "./Backdrop";
import SyncLoader from "react-spinners/GridLoader";

function Loader({ loading }) {
  return (
    loading && (
      <Backdrop>
        <div className={"upload-loader"}>
          {loading ? (
            <SyncLoader
              className="loader"
              color={"red"}
              loading={loading}
              size={20}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          ) : null}
        </div>
        <h1 className="loader-text">Uploading...</h1>
      </Backdrop>
    )
  );
}

export default Loader;
